"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var reduce_1 = tslib_1.__importDefault(require("./reduce"));
function reduceLazy(f, seed) {
    if (seed === undefined) {
        return function (iterable) {
            return (0, reduce_1.default)(f, iterable);
        };
    }
    return function (iterable) {
        return (0, reduce_1.default)(f, seed, iterable);
    };
}
exports.default = reduceLazy;
//# sourceMappingURL=reduceLazy.js.map